module.exports = __webpack_public_path__ + "img/img21.7a5a50b2.png";